import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section className="w-full py-16 md:py-24 bg-background">
      <div className="mx-auto max-w-4xl px-6 text-center">
        <h2 className="text-4xl md:text-6xl font-serif font-normal mb-6 text-foreground">
          Imagine where your brand could be in 60 days....
        </h2>
        <p className="text-lg md:text-xl text-gray-600 mb-8">
          Start now!
        </p>
        <Button size="lg" className="group" asChild>
          <Link to="/contact">
            Book an intro
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
          </Link>
        </Button>
      </div>
    </section>
  );
};

export default CTASection;